module.exports = require('./helpers/bundle-url').getBundleURL('6aCO0') + "missing_favicon.95e1df50.svg";